import error_messages from './server_error'

export function translate_error(server_error) {
  if(error_messages[server_error])
    return error_messages[server_error]
  else
    return 'عملیات مورد نظر معتبر نمی باشد'
}
export function translate_error_title(error_title) {
  let property_title = [
    'Title',
    'Address',
    'Telephone',
    'PostalCode',
    'Description',
    'MinValue',
    'MaxValue',
    'PhoneOrEmail',
    'Password',
    'Phone',
    'Email',
    'Name',
    'Family',
    'PhoneNumber',
    'MinInvest',
    'AccountNumber',
    'ShabaNumber',
    'Sex',
    'FatherName',
    'BirthCertificateNo',
    'NationalId'
  ]
  let translated_property_title = [
    'عنوان',
    'آدرس',
    'تلفن ثابت',
    'کد پستی',
    'توضیخات',
    'مقدار کمینه',
    'مقدار بیشینه',
    'نام کاربری',
    'رمز عبور',
    'تلفن',
    'ایمیل',
    'نام',
    'نام خانوادگی',
    'شماره تماس',
    'حداقل سرمایه',
    'َشماره حساب',
    'شماره شبا',
    'جنسیت',
    'نام پدر',
    'شماره شناسنامه',
    'کد ملی'
  ]

  let translated_error = ''
  for (let i=0; i< property_title.length; i++){
    if (error_title.includes(property_title[i])) {
      translated_error = error_title.replace(property_title[i], translated_property_title[i])
    }
  }

  if (translated_error !== '') {
    return translated_error
  }
  return error_title
}
